export function hasSensitiveAccountChanges(current, original) {
  return !!(current.Password || current.password) ||
    (current.UserName || current.userName || "") !== (original.userName || "") ||
    (current.Email || current.email || "") !== (original.email || "");
}
